import { ApiCall } from "../apiBase";

/********get all vouchers query********/
export async function getAllVouchers() {
  let vouchers = [];

  const result = await ApiCall({
    method: "post",
    data: {
      query: `
        query getAllVouchers {
          getAllVouchers {
            id
            code
            value
            status
            purchaserName
            purchaserEmail
            expireDate
            createdAt
            paymentId
            voucherS3URL
          }
        }
      `,
    },
  });

  if (!result.data.errors && result.data.data.getAllVouchers) {
    vouchers = result.data.data.getAllVouchers;
  }

  return vouchers;
}

/********check voucher validation query********/
export async function checkVoucherValidation(voucherCode) {
  let voucherValidres = null;

  const result = await ApiCall({
    method: "post",
    data: {
      query: `
        query checkVoucherValidation($code: String!) {
          checkVoucherValidation(code: $code) {
            valid
            message
            status
          }
        }
      `,
      variables: {
        code: voucherCode,
      },
    },
  });

  if (!result.data.errors && result.data.data.checkVoucherValidation) {
    voucherValidres = result.data.data.checkVoucherValidation;
  }

  return voucherValidres;
}

/********get a voucher by it's id query********/
export async function getVoucherById(voucherId) {
  let voucherRes = null;

  const result = await ApiCall({
    method: "post",
    data: {
      query: `
        query getVoucherById($id: ID!) {
          getVoucher(id: $id) {
            id
            code
            value
            status
            purchaserName
            purchaserEmail
            expireDate
            createdAt
            paymentId
          }
        }
      `,
      variables: {
        id: voucherId,
      },
    },
  });

  if (!result.data.errors && result.data.data.getVoucher) {
    voucherRes = result.data.data.getVoucher;
  }

  return voucherRes;
}

/********get a voucher by it's code query********/
export async function getVoucherByCode(voucherCode) {
  let voucherRes = null;

  const result = await ApiCall({
    method: "post",
    data: {
      query: `
        query getVoucherByCode($code: String!) {
          getVoucherByCode(code: $code) {
            id
            code
            value
            status
            purchaserName
            purchaserEmail
            expireDate
            createdAt
            paymentId
          }
        }
      `,
      variables: {
        code: voucherCode,
      },
    },
  });

  if (!result.data.errors && result.data.data.getVoucherByCode) {
    voucherRes = result.data.data.getVoucherByCode;
  }

  return voucherRes;
}

/********add a voucher mutation********/
export async function addVoucher(newVoucher) {
  let addVoucherRes = null;

  const result = await ApiCall({
    method: "post",
    data: {
      query: `
          mutation addVoucher($input: VoucherInput!) {
            addVoucher(input: $input) {
                id
                code
                value
                status
                purchaserName
                purchaserEmail
                expireDate
                createdAt
                paymentId
                voucherS3URL
            }
          }
        `,
      variables: {
        input: {
          value: newVoucher.voucherValue,
          purchaserEmail: newVoucher.voucherPurcherEmail,
          purchaserName: newVoucher.voucherPurchaserName,
          purchaserAddress: newVoucher.voucherPurcherAddress,
        },
      },
    },
  });


  if (!result.data.errors && result.data.data.addVoucher) {
    addVoucherRes = result.data.data.addVoucher;
  }

  return addVoucherRes;
}

/********update a voucher mutation********/
export async function updateVoucher(voucherId, voucherStatus) {
  let updateVoucherRes = null;

  const result = await ApiCall({
    method: "post",
    data: {
      query: `
        mutation updateVoucher($id: ID!, $status: Statuses!) {
          updateVoucher(id: $id, status: $status) {
            id
            code
            value
            status
            purchaserName
            purchaserEmail
            expireDate
            createdAt
            paymentId
            voucherS3URL
          }
        }
      `,
      variables: {
        id: voucherId,
        status: voucherStatus,
      },
    },
  });

  if (!result.data.errors && result.data.data.updateVoucher) {
    updateVoucherRes = result.data.data.updateVoucher;
  }

  return updateVoucherRes;
}

/********delete a voucher mutation********/
export async function deleteVoucher(voucherId) {
  let deleteSuccess = false

  const result = await ApiCall({
    method: "post",
    data: {
      query: `
          mutation deleteVoucher($id: ID!) {
            deleteVoucher(id: $id) {
              id
              code
              value
              status
              purchaserName
              purchaserEmail
              expireDate
              createdAt
              paymentId
            }
          }
        `,
      variables: {
        id: voucherId,
      },
    },
  });

  if (!result.data.errors && result.data.data.deleteVoucher) {
    deleteSuccess = true
  }

  return deleteSuccess;
}

/***************** Get Total Amount From Vouchers ****************/
export async function getTotalAmountEarnedFromVouchers() {
  let totalAmount = 0

  const result = await ApiCall({
    method: "post",
    data: {
      query: `
        query getTotalAmountFromVouchers {
          getTotalAmountFromVouchers
        }
      `
    },
  });

  if (!result.data.errors && result.data.data.getTotalAmountFromVouchers) {
    totalAmount = result.data.data.getTotalAmountFromVouchers
  }

  return totalAmount
}

/********add a voucher mutation********/
export async function getVoucherS3URL(voucherId) {
  let S3URL = null;

  const result = await ApiCall({
    method: "post",
    data: {
      query:
        `
          mutation sendS3URL($voucherId: ID!) {
            sendVoucherS3URL(voucherId: $voucherId){
              message
              status
              downloadURL
            }
          }
        `,
        variables: {
          voucherId: voucherId,
        },
    },
  });

  if (!result.data.errors && result.data.data.sendVoucherS3URL) {
    S3URL = result.data.data.sendVoucherS3URL;
  }

  return S3URL;
}
